import { API_CALL } from '../../../middleware/api';
import {
  ADD_ORAGANIZATION,
  GET_ORG_CLIENTS,
  GET_ORG_TYPES,
  UPDATE_ORAGANIZATION,
  UPDATE_ORG_TYPE,
} from './constants';

export const actions = {
  addOrganization: data => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/organizations/`,
      data,
    },
    type: ADD_ORAGANIZATION,
  }),
  updateOrganization: (id, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/organizations/${id}`,
      data,
    },
    type: UPDATE_ORAGANIZATION,
  }),
  updateOrganizationType: (id, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/organizations/${id}/type`,
      data,
    },
    type: UPDATE_ORG_TYPE,
  }),
  getOrgTypes: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/organizations/types',
    },
    type: GET_ORG_TYPES,
  }),
  getOrganizationsByType: orgType => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/organizations/',
      params: { filterBy: `org_type:${orgType}`, limit: 1000 },
    },
    type: GET_ORG_CLIENTS,
  }),
};
